// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__XufYJ","text":"styles_text__g2o15","loaderBlock":"styles_loaderBlock__Exxsm","loaderBg":"styles_loaderBg___Q00G"};